import React, { useEffect } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import CardItem from '../card-item';

import { useAuth0 } from "../../react-auth0-spa";

import {
  getPlants
} from './actions';

import './styles.scss';

const PlantItems = ({
  onLoad,
  plants
}) => {
  const { user } = useAuth0();

  useEffect(() => {
    const userId = user.sub.split('|')[1];
    onLoad(userId);
  }, [onLoad, user]);

  if (!plants.length) {
    return null;
  }

  return (
    <div className="plants-wrapper">
      {plants.map(plant => (
        <div className="plant-item" key={plant.id}>
          <CardItem
            id={plant.id}
            name={plant.name}
            plantKeyId={plant.key}
            waterStartTime={plant.waterStartTime}
            wateringCycle={plant.wateringCycle}
          />
        </div>
      ))}
    </div>
  );
};

const mapStateToProps = state => ({
  plants: _.get(state, 'plants.plants', []),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  onLoad: getPlants
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PlantItems);
